export default __webpack_public_path__ + "static/media/bg.fca41249.png";